export default __webpack_public_path__ + "static/media/imagemAP.bee2bc64.jpg";